import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import ComponentRenderer from './ComponentRenderer';

function DraggableCanvasComponent({
  component,
  index,
  moveComponent,
  onSelect,
  onRemove,
  isSelected
}) {
  const ref = useRef(null);

  const [{ handlerId }, drop] = useDrop({
    accept: 'CANVAS_COMPONENT',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      moveComponent(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'CANVAS_COMPONENT',
    item: () => {
      return { id: component.id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0.4 : 1;

  drag(drop(ref));

  return (
    <div 
      ref={ref}
      className={`canvas-component ${isSelected ? 'selected' : ''}`}
      style={{ opacity }}
      data-handler-id={handlerId}
      onClick={() => onSelect(component)}
    >
      <div className="component-controls">
        <div className="drag-handle">
          <i className="fas fa-grip-vertical"></i>
        </div>
        <div className="component-actions">
          <button
            className="action-btn duplicate"
            title="Duplicate"
            onClick={(e) => {
              e.stopPropagation();
              // Handle duplicate
            }}
          >
            <i className="fas fa-copy"></i>
          </button>
          <button
            className="action-btn delete"
            title="Delete"
            onClick={(e) => {
              e.stopPropagation();
              onRemove(component.id);
            }}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      </div>

      <div className="component-content">
        <ComponentRenderer 
          component={component}
          previewMode={false}
        />
      </div>

      <div className="component-info">
        <span className="component-type">{component.type}</span>
        <span className="component-id">#{component.id}</span>
      </div>
    </div>
  );
}

export default DraggableCanvasComponent;